import { useState } from "react";
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tab,
  Select,
  MenuItem,
  SelectChangeEvent,
} from "@mui/material";
import ReplyIcon from "@mui/icons-material/Reply";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import AddReply from "../../Modals/addReply";

interface SupportData {
  id: number;
  user: string;
  email: string;
  phone: string;
  title: string;
  description: string;
  submittedDate: string;
  status: "Pending" | "Resolved";
}

const CustomerSupport = () => {
  const navigate = useNavigate();
  const [mainTab, setMainTab] = useState(0);
  const [subTab, setSubTab] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [selectedRowStatus, setSelectedRowStatus] = useState<"Pending" | "Resolved">("Pending");

  const mainTabs = [
    "Chats",
    "Queries Received",
    "Complaints / Disputes",
    "Booking Related Disputes",
  ];

  const subTabs: ("Pending" | "Resolved")[] = ["Pending", "Resolved"];

  const [supportData, setSupportData] = useState<SupportData[]>([
    {
      id: 1,
      user: "John Doe",
      email: "john@example.com",
      phone: "+91 9876543210",
      title: "App not loading",
      description: "The app freezes when I open it.",
      submittedDate: "20 Oct 2025",
      status: "Pending",
    },
    {
      id: 2,
      user: "Alice Smith",
      email: "alice@example.com",
      phone: "+91 9123456789",
      title: "Refund not processed",
      description: "I haven't received my refund yet.",
      submittedDate: "19 Oct 2025",
      status: "Resolved",
    },
    {
      id: 3,
      user: "Bob Williams",
      email: "bob@example.com",
      phone: "+91 9988776655",
      title: "Chat not connecting",
      description: "Unable to send or receive messages.",
      submittedDate: "18 Oct 2025",
      status: "Pending",
    },
  ]);

  // Handle Status Change
  const handleStatusChange = (index: number, event: SelectChangeEvent) => {
    const updatedData = [...supportData];
    updatedData[index].status = event.target.value as "Pending" | "Resolved";
    setSupportData(updatedData);
  };

  // Handle Tabs
  const handleMainTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setMainTab(newValue);
    setSubTab(0);
  };

  const handleSubTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSubTab(newValue);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  // Filter Data Based on Subtab
  const filteredData = supportData.filter(
    (item) => item.status === subTabs[subTab]
  );

  return (
    <>
      <div className="main_title">
        <h1>Customer Support Management</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Customer Support
        </p>
      </div>

      {/* Main Tabs */}
      <Box className="custom_tabs1">
        <Tabs value={mainTab} onChange={handleMainTabChange} className="custom_tabs_links"  variant="scrollable"
  scrollButtons="auto"
  allowScrollButtonsMobile>
          {mainTabs.map((label, index) => (
            <Tab key={index} label={label} />
          ))}
        </Tabs>
      </Box>

      <div className="cards">
        {/* Search Bar */}
        <Box className="search_box mt_20">
          <SearchBar
            searchTerm={searchTerm}
            setDebouncedSearchTerm={setSearchTerm}
            placeholder="Search by user, title, or issue..."
          />
        </Box>

        {/* Sub Tabs */}
        <Box className="custom_tabs1 mt_20">
          <Tabs value={subTab} onChange={handleSubTabChange} className="custom_tabs_links">
            {subTabs.map((label, index) => (
              <Tab key={index} label={label} />
            ))}
          </Tabs>
        </Box>

        {/* Table */}
        <TableContainer className="table_container mt_20">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sr. No.</TableCell>
                <TableCell>User Details</TableCell>
                <TableCell>Title</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Submitted Date</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {filteredData.map((row, index) => (
                <TableRow key={row.id} hover>
                  <TableCell>{index + 1}</TableCell>

                  <TableCell>
                    <div className="user_block">
                      <figure>
                        <img src="/static/images/user_placeholder.png" alt="User" />
                      </figure>
                      <p>
                        <b>{row.user}</b>
                        {row.email}
                        <br />
                        {row.phone}
                      </p>
                    </div>
                  </TableCell>

                  <TableCell>{row.title}</TableCell>
                  <TableCell>{row.description}</TableCell>
                  <TableCell>{row.submittedDate}</TableCell>

                  <TableCell>
                    <Select
                      value={row.status}
                      onChange={(e) => handleStatusChange(index, e)}
                      size="small"
                      fullWidth
                    >
                      <MenuItem value="Pending">Pending</MenuItem>
                      <MenuItem value="Resolved">Resolved</MenuItem>
                    </Select>
                  </TableCell>

                  <TableCell>
                    <div className="table_actions v2">
                      <Box>
                        <IconButton
                          onClick={() => {
                            setSelectedRowStatus(row.status);
                            setOpenModal(true);
                          }}
                        >
                          <ReplyIcon />
                        </IconButton>
                      </Box>
                      <Box>
                        <IconButton>
                          <img src="/static/images/trash2_icon.svg" alt="Delete" />
                        </IconButton>
                      </Box>
                    </div>
                  </TableCell>
                </TableRow>
              ))}

              {filteredData.length === 0 && (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    No records found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      {/* Add Reply Modal */}
      {/* <AddReply
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
        status={selectedRowStatus} // Pass current row status
      /> */}
    </>
  );
};

export default CustomerSupport;
